export const DEPOSIT_PREV_PATH_LS_KEY = 'prevPathDeposit';
